import {Fragment, useEffect, useRef, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import InfiniteScroll from "react-infinite-scroll-component";
import QuotationServices from '../../../../services/Quotation.services'
import {useRouter} from "next/router";
import ToastService from "../../../../services/Toast.Service";

export default function CreateOrSelectQuotationToAddLine({
                                                             jwtToken,
                                                             open,
                                                             handleCancelAction,
                                                             handleAcceptAction,
                                                             addQuotationLine,
                                                             createNewQuotation
                                                         }) {
    const router = useRouter();
    const [page, setPage] = useState(0);
    const [offertes, setOffertes] = useState([]);
    const [moreData, setMoreData] = useState(true);
    const [reference, setReference] = useState();
    const [referenceDisabled, setReferenceDisabled] = useState(true);

    const updateReference = (input) => {
        setReference(input);

        if (input !== null && input !== "") {
            setReferenceDisabled(false);
        } else {
            setReferenceDisabled(true);
        }
    };

    useEffect(() => {
        fetchMoreData(true);
    }, []);

    const closeAction = () => {
        handleCancelAction();
    }

    const acceptAction = () => {
        handleAcceptAction();
    }

    const fetchMoreData = async (initial) => {
        if (!initial) {
            setPage(page + 1);
        }

        let newData = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/invoices?" +
            new URLSearchParams({
                limit: 20,
                page: page,
            }),
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        ).then((response) => response.json());

        if (newData[0]?.length > 0) {
            if (initial) {
                setOffertes(newData[0]);
            } else {
                setOffertes(offertes.concat(newData[0]));
            }
        }

        setMoreData(newData[0]?.length === 20);
    };


    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={closeAction}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">

                                <>
                                    <h2 className="text-sm lg:text-base">
                                        Kies een offerte om aan toe te voegen
                                        <div
                                            className="absolute top-4 right-[4%] w-6 h-6 cursor-pointer"
                                            onClick={() => closeAction()}
                                        >
                                            <div
                                                className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 rotate-45 rounded-[1px]"></div>
                                            <div
                                                className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 -rotate-45 rounded-[1px]"></div>
                                        </div>
                                    </h2>
                                    <div className="w-full h-80 overflow-y-auto mt-4">
                                        <InfiniteScroll
                                            dataLength={offertes ? offertes?.length : 0}
                                            next={fetchMoreData}
                                            hasMore={offertes ? moreData : false}
                                            className="!overflow-hidden"
                                            loader={
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="animate-spin w-12 h-12 lg:w-16 lg:h-16 mx-auto mt-8 fill-olaf-orange-500"
                                                >
                                                    <path
                                                        d="M304 48C304 74.51 282.5 96 256 96C229.5 96 208 74.51 208 48C208 21.49 229.5 0 256 0C282.5 0 304 21.49 304 48zM304 464C304 490.5 282.5 512 256 512C229.5 512 208 490.5 208 464C208 437.5 229.5 416 256 416C282.5 416 304 437.5 304 464zM0 256C0 229.5 21.49 208 48 208C74.51 208 96 229.5 96 256C96 282.5 74.51 304 48 304C21.49 304 0 282.5 0 256zM512 256C512 282.5 490.5 304 464 304C437.5 304 416 282.5 416 256C416 229.5 437.5 208 464 208C490.5 208 512 229.5 512 256zM74.98 437C56.23 418.3 56.23 387.9 74.98 369.1C93.73 350.4 124.1 350.4 142.9 369.1C161.6 387.9 161.6 418.3 142.9 437C124.1 455.8 93.73 455.8 74.98 437V437zM142.9 142.9C124.1 161.6 93.73 161.6 74.98 142.9C56.24 124.1 56.24 93.73 74.98 74.98C93.73 56.23 124.1 56.23 142.9 74.98C161.6 93.73 161.6 124.1 142.9 142.9zM369.1 369.1C387.9 350.4 418.3 350.4 437 369.1C455.8 387.9 455.8 418.3 437 437C418.3 455.8 387.9 455.8 369.1 437C350.4 418.3 350.4 387.9 369.1 369.1V369.1z"/>
                                                </svg>
                                            }
                                        >
                                            {offertes
                                                ?.filter((a) => a.status == "DRAFT")
                                                .map(({uid, trackingNumber, reference}, i) => (
                                                    <div
                                                        key={uid}
                                                        className="odd:bg-[#F6F5F3] flex justify-between items-center py-3 px-6 cursor-pointer hover:bg-olaf-green-400/60"
                                                        onClick={() => addQuotationLine(uid)}
                                                    >
                                                        <p className="text-sm">
                                                            {reference ? reference : "#" + trackingNumber}
                                                        </p>
                                                        <img
                                                            src="/assets/icon/chevron-right.svg"
                                                            alt="Remove icon"
                                                            className="ml-auto"
                                                        />
                                                    </div>
                                                ))}
                                        </InfiniteScroll>
                                    </div>

                                    <div className={"mt-4 group"}>
                                        <h2 className="text-sm lg:text-base">
                                            Of maak een nieuwe offerte aan
                                        </h2>

                                        <input
                                            className={`bg-[#F6F5F3] w-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                                referenceDisabled
                                                    ? "group-hover:border-red-500"
                                                    : "group-hover:border-white"
                                            }`}
                                            name={"name"}
                                            placeholder={"Offertenaam"}
                                            type={"text"}
                                            onChange={(e) => updateReference(e.target.value)}
                                        />

                                        <button
                                            disabled={referenceDisabled}
                                            className={`mt-4 cursor-pointer w-full h-[40px]p p-4 flex items-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 bg-transparent text-olaf-green-500 border-olaf-green-500 hover:bg-olaf-green-500 hover:text-white transition duration-200 ease-in-out ${
                                                referenceDisabled ? "cursor-not-allowed" : ""
                                            }`}
                                            onClick={() => createNewQuotation(reference)}
                                        >
                                            Nieuwe offerte maken
                                        </button>
                                    </div>
                                </>

                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}